export const GAUGE_ITEM_WIDTH = 215;
export const GAUGE_GRID_GAP = 20;
export const LEFT_PANEL_MIN_WIDTH = 250;
export const RIGHT_PANEL_MIN_WIDTH = 700;
export const RESIZE_HANDLE_WIDTH = 32;
export const RESIZE_ENABLED_MIN_WIDTH = 900;
export const MAX_RESIZED_GAUGE_GRID_COLUMNS = 10;
export const LEFT_PANEL_WIDTH_STORAGE_KEY = 'locationViewLeftPanelWidth';
